import axios from 'axios'
const baseURL = ''
const baseURL2 = process.env.NODE_ENV === 'production' ? 'http://scgzzx.cn/api/' : 'api/'

export default axios.create({
  baseURL
})



// WEBPACK FOOTER //
// ./src/http.js